import { isPayDealer$ } from '../VehicleCollectionSubjects';

import { useRxjsStore } from './useRxjsStore';

export const useIsPayDealer = () => useRxjsStore(isPayDealer$, false);
